import { AttributeValues } from './base-attribute-values';

export class SmartHomeAttributeValues extends AttributeValues {
    attributesMapping(): void {
        super.attributesMapping();

        this.attr['egl_neta_rateizzo_flag__c'] = this.currentProduct?.configurations?.installmentFlag;
        this.attr['egl_neta_cessioneCredito_flag__c'] = this.currentProduct?.configurations?.creditAssignment;
        this.attr['egl_neta_ritenutaDAcconto_flag__c'] = this.currentProduct?.configurations?.withHoldingTax;
        this.attr['egl_neta_productClass__c'] = this.currentProduct?.configurations?.productClass;
        this.attr['egl_delivery_to_floor__c'] = this.currentProduct?.configurations?.deliveryPlan;
        this.attr['egl_installation__c'] = this.currentProduct?.configurations?.installation;
        this.attr['egl_Floor__c'] = this.currentProduct?.deliveryFloor?.toString();
        this.attr['egl_consumer_credit_campaign__c'] = this.currentProduct?.configurations?.creditCampaign;
        this.attr['egl_payment_balance__c'] = this.currentProduct?.configurations?.percentageDownPayment;
    }
}
